<template>
    <div class="insert-rec insert-list">
    <p class="insert-list__title">{{cardInfo.title}}</p>
    <ul class="insert-list__ul">
        <template v-for="(item,index) in cardInfo.list">
            <li class="insert-list__li" v-if="item.title" :key="index">
                <i class="dot"></i>
                <a :href="item.url" target="_blank" :data-spm-data="cardInfo.spm+'-'+(index+1)">
                    <span class="atlas-font" v-if="item.type === 3">图集</span>
                    {{item.title}}
                </a>
            </li>
        </template>
    </ul>
</div>


</template>

<script>

export default {
    props: {
        cardInfo: {
			type: Object,
			default: () => {
				return {};
			},
		},
    },
    data() {
        return {

        }
    },
    mounted() {
    },
    
}
</script>

<style lang="less" scoped>

</style>